/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './dealer-search-result.scss';
import Dealer from '../../../../sharedmodules/state/dealer';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { buildCityStateZip } from '../../shared/services/product';

function handleDealerSelectClick(prop) {

    prop.onDealerSelectClick(prop.dealer);

}

const DealerSearchResult = (props) => (
    <section className="dealer-search-result">
        <div className="dealer-search-details">
            <div className="dealer-name">
                {`${props.dealer.name}, ${props.dealer.account}`}
            </div>
            <div className="dealer-address">
                {`${props.dealer.location.address1}, ${buildCityStateZip(props.dealer.location)}`}
            </div>
            <div className="dealer-email-phone">
                {props.dealer.email.length ? `${props.dealer.email}, ${props.dealer.phone}` : props.dealer.phone}
            </div>
        </div>
        <button
            className="button-primary"
            onClick={() => handleDealerSelectClick(props)}
        >
            <FormattedMessage id="SELECT" />
        </button>
    </section>
);

DealerSearchResult.displayName = 'DealerSearchResult';
DealerSearchResult.propTypes = {
    dealer: PropTypes.instanceOf(Dealer).isRequired,
    onDealerSelectClick: PropTypes.func.isRequired,
};

export default DealerSearchResult;
